import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logout } from '../../features/auth/authSlice';
import { RootState, AppDispatch } from '../../store/store';
import SyncStatusIndicator from '../SyncStatusIndicator';

const Header: React.FC = () => {
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const { user } = useSelector((state: RootState) => state.auth);

    const handleLogout = async () => {
        await dispatch(logout());
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        navigate('/login');
    };

    return (
        <header className="bg-blue-600 text-white p-4 flex justify-between items-center shadow-md sticky top-0 z-30">
            <h1 className="text-xl font-bold">📱 Sparepart Ponsel POS</h1>
            <div className="flex items-center gap-4">
                {/* Sync Status Indicator */}
                <SyncStatusIndicator 
                    showDetails={true}
                    size="sm"
                    className="text-white"
                />
                {user && (
                    <span className="text-sm hidden md:inline">
                        {user.username} ({user.role})
                    </span>
                )}
                <button
                    onClick={handleLogout}
                    className="bg-red-500 hover:bg-red-600 px-4 py-2 rounded text-sm font-medium transition-colors"
                >
                    Logout
                </button>
            </div>
        </header>
    );
};

export default Header;